(function () {
    angular.module('tmx-app').service('PrevilegeService', ['tmxUtility',

        function previlegeService(tmxUtility) {

            var allowedStates = ["private.dashboard", "private.logout","private.profilelink","private.profilelink.edit"];

            var service = this;
            service.CheckStatePrevilege = CheckStatePrevilege;

            function CheckStatePrevilege(stateName) {
                stateName = stateName.toLowerCase();
           
            //#region  Cache work To be done when previleges are not in local storage
            // var originalStateName = angular.copy(stateName); 
            // if(!previlegeMap.hasOwnProperty(originalStateName)) {
            //     var hasPrevilege = parseAndCheckPrevilege();
            //     previlegeMap[originalStateName] = hasPrevilege;
            //     if(storeInCache) {
            //         cacheStore.set(cacheKeyName, previlegeMap);
            //     }
            // }
            // return previlegeMap[originalStateName];
            //#endregion
                return parseAndCheckPrevilege();

                function parseAndCheckPrevilege(){
                    if (stateName.endsWith(".view")) { // remove the view part from state name because it comes from menu link and not from state names
                        stateName = tmxUtility.splitString(stateName,stateName.lastIndexOf(".view"))[0];
                    }
                    if (stateName.startsWith("public")) {
                        return true;
                    }
                    if (allowedStates.indexOf(stateName) > -1) {
                        return true;
                    }
                    var stateParts = PartitionStates();
                    var filteredLoggedInPrevileges = FilterPrevilegeByEntityName(stateParts[0]);

                    if (!filteredLoggedInPrevileges) { // If previlege for entity is not found
                        return false;
                    }

                    if (stateParts.length == 1) { //.Add and .Edit is not in state name
                    //View is already removed from state name so if .view comes in the state or not it is treated the same
                        return CheckPrevilegeInEntity(filteredLoggedInPrevileges, 'View');
                    }
                    else if (stateParts[stateParts.length - 1].toLowerCase().endsWith('add')) {
                        return CheckPrevilegeInEntity(filteredLoggedInPrevileges, 'Create');
                    }
                    else if (stateParts[stateParts.length - 1].toLowerCase().endsWith('edit')) {
                        return CheckPrevilegeInEntity(filteredLoggedInPrevileges, 'Edit');
                    }
                    return false;
                }
                function PartitionStates() {
                    if (stateName.lastIndexOf(".") < 0) {
                        return [stateName];
                    }
                    var splitStates = [stateName];
                    if (stateName.endsWith(".add")) {
                        splitStates = tmxUtility.splitString(stateName,stateName.lastIndexOf(".add"));
                    }
                    else if (stateName.endsWith(".edit")) {
                        splitStates = tmxUtility.splitString(stateName,stateName.lastIndexOf(".edit"));
                    }
                    return splitStates;
                }

            }

            function FilterPrevilegeByEntityName(entityName) {
                var userPrevileges = JSON.parse(localStorage.getItem('LoggedInUserPrivileges'));
                if (userPrevileges) {
                    var actualName = Object.keys(userPrevileges.entities).find(function (x) { return x.toLowerCase() == entityName; })
                    return userPrevileges.entities[actualName];
                }
                return null;
            }
            function CheckPrevilegeInEntity(entityPrevilegeItem, previlegeName) {
                if (entityPrevilegeItem) {
                    return entityPrevilegeItem.privileges.hasOwnProperty(previlegeName); //Check if key with the previlegeName is there in privileges object
                }
                return false;
            }
        
        }]);
})();